export const LIST_QUIZ = 'LIST_QUIZ'
export const DETAIL_QUIZ = 'DETAIL_QUIZ'
export const TOTAL_QUIZ = 'TOTAL_QUIZ'
